var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-modal",
    {
      attrs: { active: _vm.isActive, "can-cancel": false },
      on: { close: _vm.onClose }
    },
    [
      _c(
        "sc-modal-card",
        { attrs: { id: "sc-confirmation-modal" } },
        [
          _c("template", { attrs: { slot: "title" }, slot: "title" }, [
            _c("div", { staticClass: "title-container" }, [
              _c("h1", { staticClass: "modal-tile" }, [
                _vm._v(_vm._s(_vm.title))
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close-button",
                  on: {
                    click: function($event) {
                      _vm.$emit("update:isActive", false)
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-times" })]
              )
            ])
          ]),
          _vm._v(" "),
          _c("template", { attrs: { slot: "body" }, slot: "body" }, [
            _vm.$slots.default || (_vm.messages && _vm.messages.length)
              ? _c(
                  "div",
                  { staticClass: "info-texts" },
                  [
                    _vm._t(
                      "default",
                      _vm._l(_vm.messages, function(m) {
                        return _c("p", { staticClass: "message-array-item" }, [
                          _vm._v(_vm._s(m))
                        ])
                      })
                    )
                  ],
                  2
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("template", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "button",
              { staticClass: "button", on: { click: _vm.onClose } },
              [_vm._v(_vm._s(_vm.cancelText))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button",
                class: ["is-" + _vm.type],
                on: { click: _vm.onConfirm }
              },
              [_vm._v(_vm._s(_vm.confirmText))]
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5104a71d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5104a71d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/components/sc-confirmation-modal/ScConfirmationModal.vue
// module id = null
// module chunks = 